// Need to use the React-specific entry point to import createApi
import {
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import {
  getStorage,
} from '../utils/functions/localstorage';
// Define a service using a base URL and expected endpoints
const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL}/user`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');

    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const userManagementApi = createApi({
  reducerPath: 'userManagementApi',
  baseQuery,
  endpoints: (builder) => ({
    getAllAdmin: builder.query({
      query: (q) => `/?page=${q.page}&size=${q.size}`,
    }),
    createUser: builder.mutation({
      query: (payload) => ({
        url: '/',
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
    }),
    updateUser: builder.mutation({
      query: (req) => {
        const {
          params,
          body,
        } = req;
        const {
          id,
        } = params;
        return {
          url: `/${id}`,
          method: 'PUT',
          body,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        };
      },
    }),
    deleteUser: builder.mutation({
      query: (payload) => {
        const id = payload;
        return {
          url: `/${id}`,
          method: 'DELETE',
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllAdminQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = userManagementApi;
